import { AppData, Log, Utils } from '@lightningjs/sdk'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig, initSecurityToken } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import Router from '@lightningjs/sdk/src/Router'
import { AppSetup } from '../lib/app-setup'
import { PLATFORM } from '../lib/enum'
import errorHandler from '../lib/error'
import { Helper } from '../lib/helper'
import { Logger } from '../lib/logger'

export class PlatformVidaa extends PlatformBase {  

  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      179: 'PlayPause',
      227: 'Rewind',
      228: 'Forward',
      33: 'Next',
      34: 'Previous',
      27: 'Exit',
      8: 'Back',
      73: 'Info'
    }
  }

  override setKeyMappings(appSettings: any) {
    appSettings.keys = this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_REWIND = 227;
    KeyCodes.KEY_FORWARD = 228;
    KeyCodes.KEY_NEXT = 33;
    KeyCodes.KEY_PREVIOUS = 34;
    KeyCodes.KEY_BACK = 461;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_INFO = 73;
    KeyCodes.KEY_EXIT = 69;
    KeyCodes.KEY_HOME = 77;
  }

  override async initialize(): Promise<boolean> {
    this._shouldShowExitPopup = true
    Log.info('PlatformBase:', typeof this)
    const { appConfig } = AppData as AppSetup;
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    Helper.getSiteConfigInfo(this._siteConfig)            
    
    appConfig?.testEnableNativePlayer=true;
    

    if(appConfig.enableSecurityToken){
      appConfig?.apiVersion = "sv9.0";      
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }


    return new Promise(async (resolve, reject) => {
      const promiseArry = []
      promiseArry.push(this._getDeviceId())
      promiseArry.push(this._getDeviceInfo())
      resolve(true)    
    })    
  }  

  

  

  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    if (apiOptionsIcon && apiOptionsIcon !== '') {
      return apiOptionsIcon
    }
    return Utils.asset('/images/option-blue.png')    
  }
  
  override getOptionsText() {
    return 'Press Blue for Options'
  }
  
 override isOptionsKey(e: KeyboardEvent): boolean {    
    if (e.keyCode == KeyCodes.KEY_BLUE || e.code == 'KeyB') {
      return true
    }
    return false
  }

  override getIFA() {
    /*try{
        if(typeof Hisense_GetDeviceID === 'function') {
            var deviceId = Hisense_GetDeviceID();
            this._deviceId = deviceId;
            return deviceId;            
        }
    } catch(e) {
    }*/
    return '';    
  }

  _getDeviceInfo(): Promise<boolean> {
    return new Promise((resolve) => {
      Log.info("_getDeviceInfo() called");
      try{
        if(typeof Hisense_GetModelName === 'function') {
            var modelName = Hisense_GetModelName();
            this._fullModel = modelName;
            resolve(true)
        }
      } catch(e) {
        resolve(true)
      }
    })
  }

  _getDeviceId(): Promise<boolean> {
    return new Promise((resolve) => {
      Log.info("getVidaaDeviceId() called");
      try{
        if(typeof Hisense_GetDeviceID === 'function') {
            var deviceId = Hisense_GetDeviceID();
            this._deviceId = deviceId;
            resolve(true)
        }
      } catch(e) {
        resolve(true)
      }      
    })
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'close':
        if (window) {
          window.close()
        }
        break;
    }
  }

  override async getPlatformDeeplinkData(): Promise<string> {
      return new Promise((resolve, reject) => {
        let playIdFromQuery: any = Helper.urlParam('playId', location.search);
        let playIdFromParams = ''
        let isValidDeeplinkParams = false
        let navigationAssetId = ''
        
        if (isValidDeeplinkParams) {
          playIdFromParams = navigationAssetId
          Logger.processUserAction('deeplinkRawDataFromPlatform', JSON.stringify(this._params))
          Log.info('DeeplinkRawDataFromPlatform:', this._params)
          resolve(`?playId=${playIdFromParams}&src=hs-search`)
        } else if (!Helper.isEmpty(playIdFromQuery)) {
          Logger.processUserAction('deeplinkRawDataFromQueryString', playIdFromQuery)
          Log.info('DeeplinkRawDataFromQueryString:', playIdFromQuery)
          // fallback to the query string
          resolve(`?playId=${playIdFromQuery}&src=hs-search`)
        } else {
          resolve('')
        }
      })
    }

    override getHlsOptions(): any {
      /*return {
        debug: false,
        // enableWebVTT: true,
        maxBufferSize: 10 * 1000 * 1000
      }*/
     var config = {
      enableWorker: false, // Essential for all Tizen models
      maxBufferLength: 25,
      maxBufferSize: 30 * 1000 * 1000, // 30MB
      // CRITICAL: Set to a small value (1-2s) instead of 0. 
      // Setting to 0 can stop Tizen from effectively flushing old segments.
      backBufferLength: 2, 
      
      // --- STALL & GAP RECOVERY ---
      // Ensure nudgeOffset <= maxBufferHole to prevent infinite fetch loops.
      maxBufferHole: 0.5,      // Tolerates small gaps in the timeline
      nudgeOffset: 0.1,        // Smaller steps to find valid frames without skipping too much
      nudgeMaxRetry: 5,        // Stop loop after 5 failed attempts
      
      // Frequency to check if the playhead is stuck while the buffer is actually full.
      highBufferWatchdogPeriod: 3, 

      // --- LOADING STRATEGY ---
      startLevel: 0,           // Start with lowest bitrate to ensure fast startup on TV hardware
      appendErrorMaxRetry: 3,  // Prevents the player from looping on a corrupted segment
      
      // Low latency isn't recommended for older Tizen; disable for stability.
      lowLatencyMode: false 
      
    };
    return config;    
  }

  
}
